import {FarmPrinter} from "./FarmPrinter";
import {getLedHexadecimalColor, getPrinterStatusByPrinterId, LED_COLORS} from "../../../services/FarmService";
import {useSmartFarmData} from "../../../contexts/SmartFarmDataContext";

export const FarmCellPrinter = (props) => {

    const {printers, cellSize, smartFarmCellData, cellContentClasses, temperatureDisplay, humidityDisplay} = props;

    const {smartPrintersStatusData, manualPrintersStatus} = useSmartFarmData();

    const color = (smartFarmCellData && smartFarmCellData.led_color) ? getLedHexadecimalColor(smartFarmCellData.led_color) : LED_COLORS.OFF.color;
    const linearGradient = 'linear-gradient(' + color + '55, ' + color + '00)';

    return(
        <div className={cellContentClasses}>
            <div className="cell-led-light">
                <div className="cell-led-light-effect" style={{backgroundImage: color !== LED_COLORS.OFF.color ? linearGradient : 'unset'}}></div>
            </div>
            <div className="cell-header">
                <div className="cell-led-line" style={{backgroundColor: color !== LED_COLORS.OFF.color ? color : 'unset'}}></div>
                <div className="cell-type">Imprimantes</div>
                <div className="cell-environment">
                    <span className="cell-environment__temp"><i className="fa fa-thermometer-half" />{temperatureDisplay}°C</span>
                    <span className="cell-environment__humidity"><i className="fa fa-tint" />{humidityDisplay}%</span>
                </div>
            </div>
            <div className="cell-body-printers cell-body">
                  <div className="cell-printers">
                      {printers && printers.map(printer =>
                          <FarmPrinter
                              printer={printer} key={printer.id} cellSize={cellSize}
                              smartPrinterStatus={getPrinterStatusByPrinterId(printer.id, smartPrintersStatusData)}
                              manualPrinterStatus={getPrinterStatusByPrinterId(printer.id, manualPrintersStatus)}
                          />
                      )}
                  </div>
            </div>
        </div>
    );
}
